var _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSkymonitorRaining(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 155.60625 140.83642",
    id: "svg5",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "layer1",
    transform: "translate(-24.770532,-103.46919)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.177019,
      fill: "#00000e",
      strokeWidth: 10.7,
      strokeLinecap: "round",
      strokeMiterlimit: 7.2
    },
    d: "M 43.351772,189.76625 H 151.14078 l 20.27955,-22.68806 8.95643,-29.51665 -17.01196,-25.29504 -24.72871,-8.79731 -25.5123,8.91886 -10.67455,21.14359 -20.653441,-11.24692 -19.502693,7.77662 -7.489921,21.26089 -20.810074,-0.99764 -9.222579,22.84292 z",
    id: "path233"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1,
      fill: "#00ccff",
      fillOpacity: 1,
      strokeWidth: 10.7,
      strokeLinecap: "round",
      strokeMiterlimit: 7.2
    },
    d: "m 54.803185,151.32223 25.663432,4.08979 -18.173512,-25.35068 z",
    id: "path286"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1,
      fill: "#0088aa",
      fillOpacity: 1,
      strokeWidth: 10.7,
      strokeLinecap: "round",
      strokeMiterlimit: 7.2
    },
    d: "m 80.466617,155.41202 1.329182,-33.1273 -19.502694,7.77662 z",
    id: "path288"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1,
      fill: "#00aad4",
      fillOpacity: 1,
      strokeWidth: 10.7,
      strokeLinecap: "round",
      strokeMiterlimit: 7.2
    },
    d: "m 102.44924,133.53164 -21.982623,21.88038 1.329182,-33.1273 20.653441,11.24692",
    id: "path290"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1,
      fill: "#2ad4ff",
      fillOpacity: 1,
      strokeWidth: 10.7,
      strokeLinecap: "round",
      strokeMiterlimit: 7.2
    },
    d: "M 43.351772,189.76625 80.466617,155.41202 54.803185,151.32223 Z",
    id: "path292"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1,
      fill: "#0088aa",
      fillOpacity: 1,
      strokeWidth: 10.7,
      strokeLinecap: "round",
      strokeMiterlimit: 7.2
    },
    d: "M 43.351772,189.76625 H 97.246275 L 80.466617,155.41202 Z",
    id: "path294"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1,
      fill: "#0088aa",
      fillOpacity: 1,
      strokeWidth: 10.7,
      strokeLinecap: "round",
      strokeMiterlimit: 7.2
    },
    d: "m 80.466617,155.41202 21.982623,-21.88038 23.92527,26.17465 -45.907893,-4.29427",
    id: "path296"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1,
      fill: "#006680",
      fillOpacity: 1,
      strokeWidth: 10.7,
      strokeLinecap: "round",
      strokeMiterlimit: 7.2
    },
    d: "m 80.466617,155.41202 45.907893,4.29427 -29.128235,30.05996 z",
    id: "path298"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1,
      fill: "#00aad4",
      fillOpacity: 1,
      strokeWidth: 10.7,
      strokeLinecap: "round",
      strokeMiterlimit: 7.2
    },
    d: "m 126.37451,159.70629 5.62346,30.05996 H 97.246275 l 29.128235,-30.05996",
    id: "path300"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1,
      fill: "#2ad4ff",
      fillOpacity: 1,
      strokeWidth: 10.7,
      strokeLinecap: "round",
      strokeMiterlimit: 7.2
    },
    d: "m 151.14078,189.76625 -24.76627,-30.05996 5.62346,30.05996 h 19.14281",
    id: "path302"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1,
      fill: "#0088aa",
      fillOpacity: 1,
      strokeWidth: 10.7,
      strokeLinecap: "round",
      strokeMiterlimit: 7.2
    },
    d: "m 151.14078,189.76625 2.56467,-25.79449 -27.33094,-4.26547 24.76627,30.05996",
    id: "path2529"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1,
      fill: "#55ddff",
      fillOpacity: 1,
      strokeWidth: 10.7,
      strokeLinecap: "round",
      strokeMiterlimit: 7.2
    },
    d: "m 171.42033,167.07819 -17.71488,-3.10643 -2.56467,25.79449 20.27955,-22.68806",
    id: "path2531"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1,
      fill: "#00aad4",
      fillOpacity: 1,
      strokeWidth: 10.7,
      strokeLinecap: "round",
      strokeMiterlimit: 7.2
    },
    d: "m 126.37451,159.70629 54.00225,-22.14475 -8.95643,29.51665 -45.04582,-7.3719",
    id: "path2609"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1,
      fill: "#55ddff",
      fillOpacity: 1,
      strokeWidth: 10.7,
      strokeLinecap: "round",
      strokeMiterlimit: 7.2
    },
    d: "m 126.37451,159.70629 3.16958,-31.38913 34.12108,16.09731 z",
    id: "path2621"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1,
      fill: "#0088aa",
      fillOpacity: 1,
      strokeWidth: 10.7,
      strokeLinecap: "round",
      strokeMiterlimit: 7.2
    },
    d: "m 163.66517,144.41447 -0.30037,-32.14797 17.01196,25.29504 -16.71159,6.85293",
    id: "path2623"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1,
      fill: "#00aad4",
      fillOpacity: 1,
      strokeWidth: 10.7,
      strokeLinecap: "round",
      strokeMiterlimit: 7.2
    },
    d: "m 129.54409,128.31716 33.82071,-16.05066 0.30037,32.14797 z",
    id: "path2625"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1,
      fill: "#00ccff",
      fillOpacity: 1,
      strokeWidth: 10.7,
      strokeLinecap: "round",
      strokeMiterlimit: 7.2
    },
    d: "m 138.63609,103.46919 -9.092,24.84797 33.82071,-16.05066 z",
    id: "path2627"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1,
      fill: "#0088aa",
      fillOpacity: 1,
      strokeWidth: 10.7,
      strokeLinecap: "round",
      strokeMiterlimit: 7.2
    },
    d: "m 113.12379,112.38805 25.5123,-8.91886 -9.092,24.84797 -16.4203,-15.92911",
    id: "path2629"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1,
      fill: "#00ccff",
      fillOpacity: 1,
      strokeWidth: 10.7,
      strokeLinecap: "round",
      strokeMiterlimit: 7.2
    },
    d: "m 102.44924,133.53164 10.67455,-21.14359 16.4203,15.92911 z",
    id: "path2631"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1,
      fill: "#00aad4",
      fillOpacity: 1,
      strokeWidth: 10.7,
      strokeLinecap: "round",
      strokeMiterlimit: 7.2
    },
    d: "m 102.44924,133.53164 23.92527,26.17465 3.16958,-31.38913 -27.09485,5.21448",
    id: "path2633"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1,
      fill: "#00ccff",
      fillOpacity: 1,
      strokeWidth: 10.7,
      strokeLinecap: "round",
      strokeMiterlimit: 7.2
    },
    d: "M 24.770532,173.16751 54.803185,151.32223 33.993111,150.32459 Z",
    id: "path2689"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1,
      fill: "#00aad4",
      fillOpacity: 1,
      strokeWidth: 10.7,
      strokeLinecap: "round",
      strokeMiterlimit: 7.2
    },
    d: "m 24.770532,173.16751 18.58124,16.59874 11.451413,-38.44402 z",
    id: "path2691"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#999999",
      strokeWidth: 10.7,
      strokeLinecap: "round",
      strokeMiterlimit: 7.2
    },
    id: "rect411",
    width: 2.5297639,
    height: 28.629992,
    x: 43.351772,
    y: 206.42149
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#808080",
      strokeWidth: 10.7,
      strokeLinecap: "round",
      strokeMiterlimit: 7.2
    },
    id: "rect411-6",
    width: 2.5297639,
    height: 28.629992,
    x: 66.092216,
    y: 195.866
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#999999",
      strokeWidth: 10.7,
      strokeLinecap: "round",
      strokeMiterlimit: 7.2
    },
    id: "rect411-6-7",
    width: 2.5297639,
    height: 28.629992,
    x: 81.036804,
    y: 215.67564
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#cccccc",
      strokeWidth: 10.7,
      strokeLinecap: "round",
      strokeMiterlimit: 7.2
    },
    id: "rect411-6-3",
    width: 2.5297639,
    height: 28.629992,
    x: 95.981392,
    y: 201.36064
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#cccccc",
      strokeWidth: 10.7,
      strokeLinecap: "round",
      strokeMiterlimit: 7.2
    },
    id: "rect411-6-1",
    width: 2.5297639,
    height: 28.629992,
    x: 114.35652,
    y: 211.64664
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#999999",
      strokeWidth: 10.7,
      strokeLinecap: "round",
      strokeMiterlimit: 7.2
    },
    id: "rect411-6-2",
    width: 2.5297639,
    height: 28.629992,
    x: 136.22787,
    y: 195.866
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#b3b3b3",
      strokeWidth: 10.7,
      strokeLinecap: "round",
      strokeMiterlimit: 7.2
    },
    id: "rect411-6-15",
    width: 2.5297639,
    height: 28.629992,
    x: 151.17569,
    y: 206.42149
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkymonitorRaining);
export default __webpack_public_path__ + "static/media/skymonitor-raining.f581580c5a55080b3b3d1c6476ceffb5.svg";
export { ForwardRef as ReactComponent };